import Cookies from "js-cookie";

export const isAuthenticated = () => Cookies.get("access_token_portal");